import { Navigate } from "react-router-dom";
import AllAplications from "./views/all-aplications/AllAplications";

export const routes = [
    { path: '/all-applications', element: <AllAplications /> },
    { path: '*', element: <Navigate to='/all-applications' /> },
]